var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md:flex mt-6"},[_c('div',{class:[
      { 'md:w-1/4': _vm.type === 'sm' },
      { 'md:w-1/3': _vm.type === 'md' },
      { 'md:w-1/2': _vm.type === 'lg' } ]},[_c('h2',{staticClass:"text-xl font-bold text-gray-800"},[_vm._v(_vm._s(_vm.title))]),(_vm.hasDescription)?_c('div',{staticClass:"text-sm text-gray-600 leading-tight md:mr-8 xl:mr-16"},[_vm._t("description",function(){return [_c('p',[_vm._v(_vm._s(_vm.description))])]})],2):_vm._e()]),_c('div',{staticClass:"mt-6 md:mt-0",class:[
      { 'md:w-3/4': _vm.type === 'sm' },
      { 'md:w-2/3': _vm.type === 'md' },
      { 'md:w-1/2': _vm.type === 'lg' } ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }